/**
 * Import des styles
 * ****************************************
 */
import "./sass/main.scss";

/**
 * Import des modules
 * ****************************************
 */

import Menu from "./ts/Menu";
import VideoPopups from "./ts/VideoPopups";
import Filters from "./ts/Filters";

import ScrollTriger from "./ts/ScrollTrigger";

/**
 * Initialisation des modules
 * ******************************
 */
window.onload = () => {
	/**
	 * Initialisation de scrollTrigger
	 * ******************************
	 */
	setTimeout(() => ScrollTriger(), 50)

	/**
	 * Gestion des sous-menus
	 * ******************************
	 */
	Menu();

	/**
	 * Gestion des popups "video"
	 * ******************************
	 */
	VideoPopups();

	/**
	 * Gestion des filtres
	 * ******************************
	 */
	Filters();
};
